import getRTCInstance from 'omnirtc-web';
import defaultApi from '../default/index.js';
import NOTICE from '../notice';
import { deviceListReport } from './device.js';
import TalBeauty from '../tencent-webar/index.js';

// Device Test Token
const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBpZCI6IkRldmljZSBUZXN0Iiwicm9vbVN0ciI6IkRldmljZSBUZXN0IiwidXNlciI6MCwiYXR0YWNoVG9rZW4iOiJEZXZpY2UgVGVzdCIsInR5cGUiOjcsImlhdCI6MTUxNjIzOTAyMn0.-KxkA5lfSvCNF2iosqcu4vxqhA8rl8l05mUkWxlvEgE';
const rtc = getRTCInstance(token);
/**
 * @type {import('omnirtc-web').VideoEncoderConfiguration}
 */
const videoEncoderConfig = {
  width: 640,
  height: 480,
  frameRate: 15,
  bitrateMax: 500,
};

const tracks = {
  /**
   * @type {import('omnirtc-web').ICameraVideoTrack | null}
   */
  video: null,
  /**
   * @type {import('omnirtc-web').ILocalVideoTrack | null}
   */
  beauty: null,
  /**
   * @type {import('omnirtc-web').IMicrophoneAudioTrack | null}
   */
  audio: null,
};

const globalVariables = {
  previewDomId: '',
};

if (!window.zbztAVSDK_device_checker_init) {
  window.zbztAVSDK_device_checker_init = {
    microphone: {
      hasTest: false,
      list: [],
      use: '',
      name: ''
    },
    camera: {
      hasTest: false,
      list: [],
      use: '',
      name: ''
    },
    speaker: {
      hasTest: false,
      list: [],
      use: '',
      name: ''
    }
  };
}

export const getCameraDeviceList = async () => {
  return rtc.getCameras().then((cameras) => {
    const devices = cameras.map((camera, index) => ({
      deviceId: camera.deviceId,
      deviceName: camera.label,
      isDefault: index === 0,
    }));
    window.zbztAVSDK_device_checker_init.camera.list = devices;
    window.zbztAVSDK_device_checker_init.camera.hasTest = true;
    defaultApi.writeLog(`getCameraDeviceList, ${JSON.stringify(devices)}`);
    return devices;
  });
};

export const getSpeakerDeviceList = async () => {
  return rtc.getPlaybackDevices().then((speakers) => {
    const devices = speakers.map((speaker, index) => ({
      deviceId: speaker.deviceId,
      deviceName: speaker.label,
      isDefault: index === 0,
    }));
    window.zbztAVSDK_device_checker_init.speaker.list = devices;
    window.zbztAVSDK_device_checker_init.speaker.hasTest = true;
    defaultApi.writeLog(`getSpeakerDeviceList, ${JSON.stringify(devices)}`);
    return devices;
  });
};

export const getMicrophoneDeviceList = async () => {
  return rtc.getMicrophones().then((microphones) => {
    const devices = microphones.map((microphone, index) => ({
      deviceId: microphone.deviceId,
      deviceName: microphone.label,
      isDefault: index === 0,
    }));
    window.zbztAVSDK_device_checker_init.microphone.list = devices;
    window.zbztAVSDK_device_checker_init.microphone.hasTest = true;
    defaultApi.writeLog(`getMicrophoneDeviceList, ${JSON.stringify(devices)}`);
    return devices;
  });
};

export const setCameraDevice = async ({deviceId}) => {
  window.zbztAVSDK_device_checker_init.camera.use = deviceId;
  window.zbztAVSDK_device_checker_init.camera.name = deviceListReport.cameraList[deviceId];
  if (tracks.video && tracks.video.setDevice) {
    await tracks.video.setDevice(deviceId);
    if (TalBeauty.isUsing) {
      await startBeauty(tracks.video);
      if (globalVariables.previewDomId) {
        tracks.beauty.play(globalVariables.previewDomId);
      }
      return tracks.beauty;
    }
  }
  return tracks.video;
};

export const setSpeakerDevice = async ({deviceId}) => {
  window.zbztAVSDK_device_checker_init.speaker.use = deviceId;
  window.zbztAVSDK_device_checker_init.speaker.name = deviceListReport.speakerList[deviceId];
};

export const setMicrophoneDevice = async ({deviceId}) => {
  window.zbztAVSDK_device_checker_init.microphone.use = deviceId;
  window.zbztAVSDK_device_checker_init.microphone.name = deviceListReport.micList[deviceId];
  if (tracks.audio && tracks.audio.setDevice) {
    tracks.audio.setDevice(deviceId);
  }
};

export const startCamera = async () => {
  if (tracks.video) {
    defaultApi.writeLog('startCamera tracks.video is exist');
    return;
  }

  const config = {
    encoderConfig: videoEncoderConfig,
    cameraId: window.zbztAVSDK_device_checker_init.camera.use,
  };

  tracks.video = await rtc.createCameraVideoTrack(config);

  let track;
  if (TalBeauty.isUsing) {
    await startBeauty(tracks.video);
    track = tracks.beauty;
  } else {
    track = tracks.video;
  }

  if (globalVariables.previewDomId) {
    track.stop();
    track.play(globalVariables.previewDomId);
  }

  return track;
};

export const stopCamera = async () => {
  if (tracks.video) {
    tracks.video.stop();
    tracks.video.close();
    tracks.video = null;
  }
};

/**
 * 
 * @param {import('omnirtc-web').ILocalVideoTrack} source 
 */
const startBeauty = async (source) => {
  const beauty = TalBeauty.getInstance();
  const input = new MediaStream([source.getMediaStreamTrack()]);
  let output = await beauty.getOutput(videoEncoderConfig.frameRate);
  if (!output) {
    await beauty.initCore({ input });
    output = await beauty.getOutput(videoEncoderConfig.frameRate);
  } else {
    await beauty.updateInputStream(input);
  }

  if (tracks.beauty) {
    tracks.beauty.stop();
    tracks.beauty.close();
  }
  tracks.beauty = rtc.createCustomVideoTrack({
    mediaStreamTrack: output.getVideoTracks()[0],
  });
};

export const startPreview = async (domId) => {
  if (!domId) {
    defaultApi.writeLog('[startPreview] domId is not exist');
    return;
  }

  globalVariables.previewDomId = domId;
  if (TalBeauty.isUsing) {
    tracks.beauty && tracks.beauty.play(domId);
  } else {
    tracks.video && tracks.video.play(domId);
  }
};

export const stopPreview = async () => {
  globalVariables.previewDomId = '';
  tracks.beauty && tracks.beauty.stop();
  tracks.video && tracks.video.stop();
};

export const startMicrophone = async () => {
  if (tracks.audio) {
    defaultApi.writeLog('startMicrophone tracks.audio is exist');
    return;
  }

  const config = {
    microphoneId: window.zbztAVSDK_device_checker_init.microphone,
  };

  tracks.audio = await rtc.createMicrophoneAudioTrack(config);;
  startVolumeIndicator();
  return tracks.audio;
};

export const stopMicrophone = async () => {
  if (tracks.audio) {
    tracks.audio.stop();
    tracks.audio.close();
    tracks.audio = null;
  }
};

export const startVolumeIndicator = async () => {
  if (tracks.audio) {
    setTimeout(() => {
      const level = (tracks.audio.getVolumeLevel() * 100) >> 0;
      NOTICE.captureMicVolumeChanged({
        volume: level,
      });
      startVolumeIndicator();
    }, 1000);
  }
};

export const openOrCloseCamera = async (operation) => {
  return operation ? startCamera() : stopCamera();
};

export const openOrCloseMicrophone = async (operation) => {
  return operation ? startMicrophone() : stopMicrophone();
};

export const getOrLocateVideo = async (isLocal, streamId, domId) => {
  if (isLocal) {
    return startPreview(domId);
  } else {
    defaultApi.writeLog('Please init() first');
  }
};

/**
 * 
 * @param {import('omnirtc-web').VideoEncoderConfiguration} config 
 */
export const updateVideoEncoderConfig = async (config) => {
  if (config.width) {
    videoEncoderConfig.width = config.width;
  }
  if (config.height) {
    videoEncoderConfig.height = config.height;
  }
  if (config.frameRate) {
    videoEncoderConfig.frameRate = config.frameRate;
  }
  if (config.bitrateMax) {
    videoEncoderConfig.bitrateMax = config.bitrateMax;
  }
  if (tracks.video) {
    tracks.video.setEncoderConfiguration(config);
  }
};

export const destroyEngine = async () => {
  stopCamera();
  stopPreview();
  stopMicrophone();
};
